import { defineComponent as _defineComponent } from 'vue'
import { ref, provide, computed, watch } from 'vue';
import { throttle } from '../../../utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'Swiper',
  props: {
    activeIndex: null
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  activeIndex: number;
};





const activeSwiperIndex = ref(0);
const swiperItemNumber = ref(0);
const swiperRef = ref();
const translateX = ref(0);

watch(
  () => props.activeIndex,
  val => {
    activeSwiperIndex.value = val;
    translateX.value =
      0 - swiperRef.value.offsetWidth * activeSwiperIndex.value;
  }
);

watch(activeSwiperIndex, () => {
  emits('change', activeSwiperIndex.value);
});

provide('swiper', {
  activeSwiperIndex,
  swiperRef,
  addSwiperItem,
  removeSwiperItem,
});

const touchData = {
  x: 0,
  y: 0,
};

function isActiveDot(index: number) {
  return index === activeSwiperIndex.value;
}

function addSwiperItem() {
  swiperItemNumber.value += 1;
}

function removeSwiperItem() {
  swiperItemNumber.value -= 1;
}

const swiperStyle = computed(() => {
  return { transform: `translateX(${translateX.value}px)` };
});

let isInOnceTouch = false;
function handleTouchStart(event: TouchEvent) {
  if (event.touches.length > 1 || isInOnceTouch) {
    return;
  }
  isInOnceTouch = true;
  touchData.x = event.changedTouches[0].pageX;
  touchData.y = event.changedTouches[0].pageY;
}

const handleTouchMoveThrottle = throttle(handleTouchMove, 200);

function handleTouchMove(event: TouchEvent) {
  if (event.touches.length > 1 || !isInOnceTouch) {
    isInOnceTouch = false;
    translateX.value =
      0 - swiperRef.value.offsetWidth * activeSwiperIndex.value;
    return;
  }
  const offsetX = event.changedTouches[0].pageX - touchData.x;
  translateX.value =
    0 - swiperRef.value.offsetWidth * activeSwiperIndex.value + offsetX;
}

function handleTouchEnd(event: TouchEvent) {
  if (!isInOnceTouch) {
    return;
  }
  isInOnceTouch = false;
  const offsetX = event.changedTouches[0].pageX - touchData.x;
  if (
    Math.abs(event.changedTouches[0].pageX - touchData.x) >
    swiperRef.value.offsetWidth / 5
  ) {
    if (offsetX < 0 && activeSwiperIndex.value < swiperItemNumber.value - 1) {
      activeSwiperIndex.value = activeSwiperIndex.value + 1;
    }
    if (offsetX > 0 && activeSwiperIndex.value >= 1) {
      activeSwiperIndex.value = activeSwiperIndex.value - 1;
    }
  }
  translateX.value = 0 - swiperRef.value.offsetWidth * activeSwiperIndex.value;
}

return { __sfc: true,props, emits, activeSwiperIndex, swiperItemNumber, swiperRef, translateX, touchData, isActiveDot, addSwiperItem, removeSwiperItem, swiperStyle, isInOnceTouch, handleTouchStart, handleTouchMoveThrottle, handleTouchMove, handleTouchEnd }
}

})